import React from "react";
import EmailSignatureForm from "./components/EmailSignatureForm";

function App() {
  return (
    <div className="App">
      <EmailSignatureForm />
    </div>
  );
}

export default App;
